// extracted by mini-css-extract-plugin
export default {"card":"PropertyCard_card__cIGEj","price":"PropertyCard_price__bF+ex","agentInfo":"PropertyCard_agentInfo__5SITK","icons":"PropertyCard_icons__Rde8x"};